import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import linkExpiredImg from 'assets/images/link_expired.png';
import './EmailLinkExpired.scss';
import { buildLoginPath } from 'utils/pathBuilder';
import { useNavigate } from 'react-router-dom';

const EmailLinkExpired: React.FC = () => {
  const { t } = useTranslation('email_link_expired');
  const navigate = useNavigate();

  const handleResendLink = async () => {
    navigate(buildLoginPath());
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(buildLoginPath(), { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);


  return (
    <ResultDisplay
      title={t('title')}
      imageUrl={linkExpiredImg}
      onNext={handleResendLink}
      nextText={t('goTologin')}
      showFooter={true}
    >
      <div className="email-link-expired-message">
        <div>{t('message')}</div>
      </div>
    </ResultDisplay>
    );
};

export default EmailLinkExpired;

